export enum UserObjectActions {
  ChangeUserObjectId = "Change user's object ID",
  ActivateNewPriceList = 'Activate new price list for user',
  NewPriceListActivated = 'New price list was activated successfully',
}

export enum UserProfileActions {
  RequestDataForUserProfile = 'Request data for user profile (also known as UserObject)',
  DataForUserProfileAccepted = 'Data for user profile is accepted',
  DataForUserProfileRejected = 'Data for user profile is rejected',

  RequestSaveObject = 'Request for saving user profile (alsow known as UserObject)',
  UpdatingUserProfileIsAccepted = 'Request for saving user profile is accepted',
  UpdatingUserProfileIsRejected = 'Data for saving user profile is rejected',
  RequestDeleteUserProfileLogo = 'Request for deleting user profile logo',
  RequestDeleteUserProfileLogoAccepted = 'Request for deleting user profile logo is accepted',
  RequestDeleteUserProfileLogoRejected = 'Request for deleting user profile logo is rejected',
  RequestUpdateUserProfileLogo = 'Request for update user profile logo',
  RequestUpdateUserProfileLogoAccepted = 'Request for update user profile logo is accepted',
  RequestUpdateUserProfileLogoRejected = 'Request for update user profile logo is rejected',
  UserProfileLogoWasDeleted = 'User profile logo was deleted',
  UpdateUserCurrency = 'User profile update currency',
}

export enum UserSettingsActions {
  RequestDataForUserSettings = 'Request data for user settings (also known as UserObject)',
  DataForUserSettingsAccepted = 'Data for user settings is accepted',
  DataForUserSettingsRejected = 'Data for user settings is rejected',

  RequestUpdateForUserSettings = 'Request update for user settings (also known as UserObject)',
  SettingsUpdateAccepted = 'Request for saving user settings is accepted',
  SettingsUpdateRejected = 'Request for saving user settings is rejected',
}

export enum DateTimeFormatActions {
  ChangeDateTimeFormatValues = 'Change date and time format for user preferences',
  ValidateDateTimeFormatValues = 'Validate that date and time format are valid',
}

export enum CountryDictionary {
  DictionaryAccepted = 'Country dictionary accepted',
  RequestUpdate = 'Request country dictionar update',
}

export enum ObjectType {
  ObjectAccepted = 'Object type accepted',
  RequestUpdate = 'Request object type update',
}
